import { SidebarContainer, Icon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLinkR, SidebarLink } from './SidebarElements'
import { FaInstagram } from "react-icons/fa";
import { IoLogoTiktok } from "react-icons/io5";
import { HashLink } from 'react-router-hash-link';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
        <Icon onClick={toggle}>
            <CloseIcon />
        </Icon>
        <SidebarWrapper>
          <SidebarMenu>
            <SidebarLinkR to="/menu" onClick={toggle}>
              Menu
            </SidebarLinkR>
            <HashLink to="/#about2" offset={-50} onClick={toggle} className='sidebarLink' >
              About us
            </HashLink>
            <HashLink to="/#contact" offset={60} onClick={toggle} className='sidebarLink' >
              Contact us
            </HashLink>
            <HashLink to="/#booking" offset={60} onClick={toggle} className='sidebarLink'>
              Book table
            </HashLink>
            <a href='https://billetto.se/e/vocco-night-access-biljetter-2027863?utm_source=organiser&utm_medium=share&utm_campaign=copy_link&utm_content=2' onClick={toggle} className='sidebarLink'>
              Buy tickets
            </a>
            <div className="sidebar-col ">
              <br /> <br />
              <div className="social-links_sidebar">
                <a href='https://www.instagram.com/voccosthlm/'><FaInstagram /></a>
                <a href='https://www.tiktok.com/@vocco.sthlm'><IoLogoTiktok className='icon2' /></a>
              </div>
            </div>
          </SidebarMenu>
        </SidebarWrapper>
    </SidebarContainer>
  )
}

export default Sidebar